import { Currency } from '@landr/pricing';
import { ZeroDecimalCurrenciesEnum } from '@landr/core';

// https://mixgenius.atlassian.net/browse/SP-7242
// @landr/pricing provide useFormattedPrice, but this hook do not return a function that could be use in map
export const addCurrencyToPrice = (currency?: Currency, price?: number) => {
    if (!currency || !price) {
        return '';
    }

    const isZeroDecimalValueCurrency =
        currency.currencyCode in ZeroDecimalCurrenciesEnum;

    const priceRounded = isZeroDecimalValueCurrency ? price : price.toFixed(2);

    const priceWithCurrency =
        currency.currencySymbol === '$'
            ? `${currency.currencySymbol}${priceRounded}`
            : `${priceRounded}${currency.currencySymbol}`;

    return priceWithCurrency;
};
